/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EmployeeType = {
    EMPLOYEE: 'EMPLOYEE',
    TEMP: 'TEMP'
} as const;
export type EmployeeType = typeof EmployeeType[keyof typeof EmployeeType];

